import { createContext } from "react";

export const MuteParticipantContext = createContext();
